// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AgreementModal_wrapper__1pNsB","modal":"AgreementModal_modal__LVRhO","body":"AgreementModal_body__2GnBy"};